export default {
      id: "recordVoiceOver-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#recordVoiceOver-usage",
      toString: function () {
        return this.url;
      }
    }